<script lang="ts">
	import type { ProductForCustomer } from "../../../../core/schema/Product.js";
	import type { ProductSize } from "../../../../core/schema/ProductSize.js";
	import { productSizeKeyMap } from "../../../../core/schema/productSizeKeyMap.js";
	import { ProductSizeLabelType } from "../../../../core/schema/ProductSizeLabelType.js";
	import { productSizeLabelTypeShorthandNameMap } from "../../../../core/schema/names/productSizeLabelTypeShorthandNameMap.js";
	import { formatNumber } from "../../../../core/utils/formatNumber.js";
	import { getGlobalSettings } from "../../getGlobalSettings.js";
	import { createEventDispatcher } from "svelte";

	let heightClass = "";
	export { heightClass as class };

	export let size: ProductSize;
	export let selectedSize: ProductSize;
	export let product: ProductForCustomer;
	export let isSizeAddedToCart: boolean;
	export let availableWithOption: boolean;

	const { TENANT_LOCALE } = getGlobalSettings();
	const dispatch = createEventDispatcher();

	$: customSizeLabel = product.sizeLabel && product.sizeLabel.type !== ProductSizeLabelType.Serving;

	/* eslint-disable @typescript-eslint/explicit-function-return-type */
</script>

{#if product.priceForCustomer[productSizeKeyMap[size]]}
	{@const id = `${product.id}-${size}`}
	<span class="{heightClass} relative flex shrink-0" class:aspect-square={!customSizeLabel}>
		<input
			class="custom-radio {isSizeAddedToCart
				? '[&:checked+label]:!bg-tertiary [&:checked+label]:!border-tertiary [&:checked+label]:!pointer-events-none'
				: ''}"
			{id}
			bind:group={selectedSize}
			disabled={!availableWithOption}
			name="size"
			type="radio"
			value={size}
			on:change={() => dispatch("change")}
		/>
		<label
			class:aspect-square={!customSizeLabel}
			class:px-2={customSizeLabel}
			class="{heightClass} {!availableWithOption ? '!border-gray-300 !text-gray-300' : ''}"
			for={id}
		>
			{#if product.sizeLabel && product.sizeLabel.type !== ProductSizeLabelType.Serving}
				<div class="flex gap-0.5">
					<span>{formatNumber(product.sizeLabel.values[productSizeKeyMap[size]], TENANT_LOCALE, false)}</span>
					<span class="lowercase">{productSizeLabelTypeShorthandNameMap[product.sizeLabel.type]}</span>
				</div>
			{:else}
				{size}
			{/if}
		</label>
	</span>
{/if}
